  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  Array.from(document.querySelectorAll(".fls-header__js-modal")).forEach(el => el.addEventListener("click", (e) => openModalCountry()));
  document.getElementById("fls-CountryModal__close").addEventListener("click", (e) => closeModalCountry());
  window.onclick = (e) => {
    if (e.target == document.getElementById("fls-CountryModal")) {
      closeModalCountry();
    }
  };

  function openModalCountry() {
    document.querySelector("body").classList.add("overflow-hidden");
    document.getElementById("fls-CountryModal").classList.remove("hidden");
    document.querySelector(".fls-CountryModal__container").classList.add("openSlide");  
  }

  function closeModalCountry() {
    document.querySelector(".fls-CountryModal__container").classList.remove("openSlide");  
    document.getElementById("fls-CountryModal").classList.add("hidden");
    document.querySelector("body").classList.remove("overflow-hidden");
  }